import AddCustomerPointModal from './add-customer-point-modal.vue'
export default AddCustomerPointModal
